// Last five results as W/D/L, latest on the left. One request per competition.

import React, { useEffect, useState } from "react";
import API from "../api";
import { CURRENT_SEASON } from "../constants/season";

const RESULT_CLASS = {
  W: "bg-green-600 text-white border-green-600",
  D: "bg-amber-400 text-amber-950 border-amber-400",
  L: "bg-red-600 text-white border-red-600",
};

const formLoads = new Map();

function loadForm(competition) {
  const key = `${competition}|${CURRENT_SEASON}`;
  if (!formLoads.has(key)) {
    formLoads.set(
      key,
      API.get("/teams/form", { params: { competition, season: CURRENT_SEASON, limit: 5 } })
        .then((res) => (res.data && res.data.forms) || {})
        .catch(() => ({}))
    );
  }
  return formLoads.get(key);
}

function matchesFor(forms, teamName) {
  if (!forms || !teamName) return [];
  if (forms[teamName]) return forms[teamName];
  const lower = teamName.trim().toLowerCase();
  const key = Object.keys(forms).find((name) => name.trim().toLowerCase() === lower);
  return key ? forms[key] : [];
}

const TeamRecentMatches = ({ teamName, competition = "premier_league", limit = 5 }) => {
  const [matches, setMatches] = useState(null);

  useEffect(() => {
    if (!teamName || competition === "world_cup") {
      setMatches([]);
      return undefined;
    }
    let cancelled = false;
    loadForm(competition).then((forms) => {
      if (!cancelled) setMatches(matchesFor(forms, teamName).slice(0, limit));
    });
    return () => {
      cancelled = true;
    };
  }, [teamName, competition, limit]);

  if (matches === null) {
    return (
      <div className="flex items-center gap-0.5" aria-hidden>
        {Array.from({ length: limit }).map((_, i) => (
          <span key={i} className="h-[18px] w-[18px] rounded-[3px] bg-gray-100" />
        ))}
      </div>
    );
  }

  if (matches.length === 0) return null;

  const summary = matches.map((m) => m.result).join("");

  return (
    <div className="flex items-center gap-0.5" aria-label={`Recent form ${summary}, latest first`}>
      {matches.map((match, index) => (
        <span
          key={`${match.id}-${index}`}
          className={`flex h-[18px] w-[18px] items-center justify-center rounded-[3px] border text-[11px] font-bold leading-none ${
            RESULT_CLASS[match.result] || RESULT_CLASS.D
          }`}
          title={`${match.is_home ? "vs" : "@"} ${match.opponent}: ${match.scoreline}`}
        >
          {match.result}
        </span>
      ))}
    </div>
  );
};

export default TeamRecentMatches;
